// extracted by mini-css-extract-plugin
export default {"wrap":"UniversitySort_wrap__jQfUV","label":"UniversitySort_label__aoJuQ","control":"UniversitySort_control__a7QjN"};